var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollProgress",class:'decade-'+_vm.activeDecade},[_c('div',{staticClass:"scrollIndicator",class:{'is-scrolling' : _vm.isScrolling === true },style:({'transform': 'translateX(' + _vm.lPos + '%)'})})])}
var staticRenderFns = []

export { render, staticRenderFns }